import { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { PAGES } from 'constants/pages';

import { Header, HeaderTitle } from 'components/Header';
import { FutureStockVariationsList } from 'pages/Stocks/components/FutureStockVariationsList';
import { PageTitle } from 'components/PageTitle';
import { ProductWithStocksSelector } from 'pages/Stocks/components/ProductWithStocksSelector';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { WarehouseColumnSelect } from 'components/Select/WarehouseColumnSelect';
import { TotadminPermission } from 'data/__generated__';
import { PermissionGate } from 'components/PermissionGate';

export const FutureStockVariations = () => {
    const [columnId, setColumnId] = useState<string | null>(null);
    const [selectedProductId, setSelectedProductId] = useState<string | null>(null);

    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.futureStockVariations} />
                </HeaderTitle>
                <NavButtons>
                    <Link to="/stock-variation/expired-future-stock-variations">
                        <TotemPrimaryButton>Variations de stock à venir expirées</TotemPrimaryButton>
                    </Link>
                    <Link to="/stocks">
                        <TotemPrimaryButton $isSecondaryStyle>Retour</TotemPrimaryButton>
                    </Link>
                </NavButtons>
            </Header>
            <Content>
                <SelectorsContainer>
                    <WarehouseColumnSelect
                        value={columnId}
                        onChange={setColumnId}
                        label="Entrepôt"
                        dataTest="warehouse-column-selector"
                    />
                    {columnId ? (
                        <PermissionGate requiredPermissions={[TotadminPermission.MicrostoreColumnsRead]}>
                            <ProductWithStocksSelector
                                columnId={columnId}
                                productOption={selectedProductId}
                                handleProductSelect={(productId) => setSelectedProductId(productId)}
                                label="Sélectionner un produit"
                            />
                        </PermissionGate>
                    ) : null}
                </SelectorsContainer>
                {selectedProductId && columnId ? (
                    <FutureStockVariationsList productId={selectedProductId} warehouseColumnId={columnId} />
                ) : null}
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    padding: 15px;
    flex: 1;
    overflow: auto;
`;

const NavButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 15px;
`;

const SelectorsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 15px;
`;
